import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=a9fa03e2&scoped=true&"
import script from "./FormCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fa03e2",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox});
